import Vue from "vue"
import Router from "vue-router"
import index from "../pages/index"
import test from "../pages/index/test"
import test1 from "../pages/index/test1"
import test3 from "../pages/index/test3"
import test5 from "../pages/index/test5"
import newsDetail from "../pages/news/newsDetail"
import news from "../pages/news"
import partner from "../pages/partner/index"
import xplan from "../pages/xplan/index"
import about from "../pages/about/index"
import talent from "../pages/about/talent"
import contact from "../pages/about/contact"
import product from "../pages/product/index"
import solution from "../pages/solution/index"
import solutionDetail from "../pages/solution/detail"
import trusteeship from "../pages/xplan/trusteeship"
import xPartner from "../pages/xplan/xPartner"

Vue.use(Router)

export default new Router({
  // base: "/dist/", // 添加这一行，指定base路径为/web/
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        deepth: 1,
        title: "主页",
        // hideHeader:true
        activePath:'/',
      }
    },
    {
      path: "*",
      name: "index",
      component: index,
      meta: {
        deepth: 1,
        title: "主页",
        activePath:'/',
      }
    },
    {
      path: "/index",
      name: "index",
      component: index,
      meta: {
        deepth: 1,
        title: "主页",
        activePath:'/',
      }
    },
    {
      path: "/test",
      name: "test",
      component: test,
      meta: {
        hideHeader:true,
        deepth: 1,
        title: "测试页面",
      }
    },
    {
      path: "/test1",
      name: "test1",
      component: test1,
      meta: {
        deepth: 1,
        title: "测试页面1",
      }
    },
    {
      path: "/test3",
      name: "test3",
      component: test3,
      meta: {
        deepth: 1,
        title: "测试页面3",
        hideHeader:true
      }
    },
    {
      path: "/test5",
      name: "test5",
      component: test5,
      meta: {
        deepth: 1,
        title: "测试页面5",
        hideHeader:true
      }
    },
    {
      path: "/newsDetail",
      name: "newsDetail",
      component: newsDetail,
      meta: {
        deepth: 2,
        title: "新闻详情",
        activePath:'/news', //当前路由对应的导航高亮菜单
        // hideHeader:true
      }
    },
    {
      path: "/news",
      name: "news",
      component: news,
      meta: {
        // keepAlive: true,
        activePath:'/news',
        deepth: 1,
        title: "新闻动态",
      }
    },
    {
      path: "/partner",
      name: "partner",
      component: partner,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        activePath:'/partner',
        title: "合作案例",
      }
    },
    {
      path: "/xplan",
      name: "xplan",
      component: xplan,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        title: "x计划",
        activePath:'/xplan',
      }
    },
    {
      path: "/xPartner",
      name: "xPartner",
      component: xPartner,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        title: "x计划-合作案例",
        activePath:'/xplan',
      }
    },
    {
      path: "/about",
      name: "about",
      component: about,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        title: "关于我们",
        activePath:'/about',
      }
    },
    {
      path: "/contact",
      name: "talent",
      component: talent,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        title: "人才招聘",
        activePath:'/about',
      }
    },
    {
      path: "/talent",
      name: "contact",
      component: contact,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        title: "联系我们",
        activePath:'/about',
      }
    },
    {
      path: "/product",
      name: "product",
      component: product,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        title: "产品中心",
        activePath:'/product',
        // hideHeader:true
      }

    },
    {
      path: "/solution",
      name: "solution",
      component: solution,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        activePath:'/solution',
        title: "解决方案",
      }
    },
    {
      path: "/solutionDetail",
      name: "solutionDetail",
      component: solutionDetail,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        activePath:'/solution',
        title: "解决方案详情",
      }
    },
    {
      path: "/trusteeship",
      name: "trusteeship",
      component: trusteeship,
      meta: {
        // keepAlive: true,
        // deepth: 1,
        activePath:'/xplan',
        title: "全程托管",
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  // 路由导航钩子中强制重新加载来访问 session history
  beforeRouteEnter(to, from, next) {
    // if (savedPosition) {
    //   sessionStorage.setItem("position", JSON.stringify(savedPosition));
    //   window.location.reload();
    // }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js